import { render, staticRenderFns } from "./ScoreBar.vue?vue&type=template&id=18049dc9&scoped=true&"
import script from "./ScoreBar.vue?vue&type=script&lang=ts&"
export * from "./ScoreBar.vue?vue&type=script&lang=ts&"
import style0 from "./ScoreBar.vue?vue&type=style&index=0&id=18049dc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18049dc9",
  null
  
)

export default component.exports